import api, { webApi, getCsrfToken } from "../api";

export interface User {
  id?: number;
  // support both fullname 'name' and split names
  name?: string;
  firstname?: string;
  lastname?: string;
  email: string;
  role?: string;
  password?: string;
  phone?: string;
  dob?: string;
  age?: number;
  age_grade_id?: number;
  created_at?: string;
  pfp?: string; // profile photo path
}

export const getUsers = async (params?: any): Promise<any> => {
  const res = await webApi.get(`/api/admin/users`, { params });
  return res.data;
};

export const getUser = async (id: number): Promise<any> => {
  const res = await webApi.get(`/api/admin/users/${id}`);
  return res.data;
};

export const createUser = async (payload: Partial<User>): Promise<User> => {
  await getCsrfToken();
  const res = await webApi.post(`/api/admin/users`, payload);
  return res.data;
};

export const updateUser = async (
  id: number,
  payload: Partial<User>
): Promise<User> => {
  await getCsrfToken();
  const res = await webApi.put(`/api/admin/users/${id}`, payload);
  return res.data;
};

// Update the currently authenticated user's profile
export const updateCurrentUser = async (
  payload: Partial<User> | FormData
): Promise<any> => {
  await getCsrfToken();
  let config = {};
  // If uploading a file, set proper headers
  if (payload instanceof FormData) {
    config = { headers: { "Content-Type": "multipart/form-data" } };
  }
  const res = await webApi.put(`/user`, payload, config);
  return res.data;
};

// Update current user's password
export const updateCurrentUserPassword = async (payload: {
  current_password: string;
  password: string;
  password_confirmation: string;
}): Promise<any> => {
  await getCsrfToken();
  const res = await webApi.put(`/profile/password`, payload);
  return res.data;
};

export const deleteUser = async (id: number): Promise<void> => {
  await getCsrfToken();
  await webApi.delete(`/api/admin/users/${id}`);
};

export const changeUserRole = async (id: number, role: string) => {
  await getCsrfToken();
  const res = await webApi.put(`/admin/users/${id}/role`, { role });
  return res.data;
};

export const adminResetPassword = async (id: number) => {
  await getCsrfToken();
  const res = await webApi.post(`/admin/users/${id}/reset-password`);
  return res.data;
};

export const bulkDeleteUsers = async (ids: number[]) => {
  await getCsrfToken();
  const res = await webApi.post(`/admin/users/bulk-delete`, { ids });
  return res.data;
};

export const bulkChangeRoles = async (ids: number[], role: string) => {
  await getCsrfToken();
  const res = await webApi.post(`/admin/users/bulk-role`, { ids, role });
  return res.data;
};

export default {
  getUsers,
  getUser,
  createUser,
  updateUser,
  deleteUser,
  changeUserRole,
  adminResetPassword,
  bulkDeleteUsers,
  bulkChangeRoles,
};
